import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClassCardComponent } from './components/class-card/class-card.component';
import { SharedLibraryModule } from '../common/shared-library.module';
import { CourseCardComponent } from './components/course-card/course-card.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LessonCardComponent } from './components/lesson-card/lesson-card.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BaseCardComponent } from './components/base-card/base-card.component';
import { SmallCardComponent } from './components/small-card/small-card.component';
import { InstaLearnCardComponent } from './components/insta-learn-card/insta-learn-card.component';
import { NgScrollbar } from 'ngx-scrollbar';
import { LearnersEventCardComponent } from './components/learners-event-card/learners-event-card.component';


@NgModule({
  declarations: [
    ClassCardComponent,
    CourseCardComponent,
    LessonCardComponent,
    BaseCardComponent,
    SmallCardComponent,
    InstaLearnCardComponent,
    LearnersEventCardComponent
  ],
  imports: [
    CommonModule,
    SharedLibraryModule,
    MatProgressBarModule,
    MatTooltipModule,
    NgScrollbar
  ],
  exports: [
    ClassCardComponent,
    CourseCardComponent,
    LessonCardComponent,
    SmallCardComponent,
    InstaLearnCardComponent,
    LearnersEventCardComponent
  ]
})
export class ContentCardModule { }
